exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#build-nav[data-v-28ded441]{height:64px}.builder-logo[data-v-28ded441]{max-height:40px}.v-toolbar--fixed[data-v-28ded441]{z-index:10}.build-controls[data-v-28ded441]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;min-width:420px}.extra-padding[data-v-28ded441]{padding-left:70px}.camera-btn[data-v-28ded441]{background-color:#006aff}.mobile-nav[data-v-28ded441]{width:250px}@media (max-width:959px){.v-navigation-drawer--is-mobile[data-v-28ded441],.v-navigation-drawer--temporary[data-v-28ded441]{z-index:99999999}}", ""]);

// exports
